<template>
  <BaseSearchWrapper
    :index-name="indexName"
    filters="status: live"
  >
    <div class="max-md:hidden md:col-span-4 xl:col-span-3">
      <div class="bg-gray-100">
        <div class="px-4 py-2 border-b border-gray-300">
          <h2
            class="heading-sm"
            v-text="'Filters'"
          />
        </div>
        <BaseSearchFilters
          attribute="primary_category"
          subheading-text="Primary Category"
        />
      </div>
    </div>

    <div class="col-span-12 md:col-span-8 flex flex-col gap-y-6">
      <h1
        class="heading-md"
        v-text="'Site Search'"
      />

      <div class="flex flex-col gap-y-2">
        <BaseSearchStats />

        <div class="flex gap-6 md:gap-12 md:items-center max-md:flex-col">
          <div class="flex-1">
            <BaseSearchBox />
          </div>

          <div class="flex gap-x-6 justify-between">
            <BaseMobileSearchFilters
              attribute="primary_category"
              subheading-text="Primary Category"
            />

            <BaseSearchSort :index-name="indexName" />
          </div>
        </div>
      </div>

      <AisHits>
        <template #default="{ items }: { items: AisHit[] }">
          <template v-if="items.length > 0">
            <ul class="flex flex-col gap-y-6">
              <BaseSearchResult
                v-for="item in items"
                :key="item.objectID"
                :result="item"
              />
            </ul>
          </template>
          <div v-else>
            <p v-text="'Your search did not return any results.'" />
          </div>
        </template>
      </AisHits>

      <BaseSearchPagination />
    </div>
  </BaseSearchWrapper>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { AisHits } from 'vue-instantsearch/vue3/es'

import BaseSearchBox from '@js/components/search/BaseSearchBox.vue'
import BaseSearchSort from '@js/components/search/BaseSearchSort.vue'
import BaseSearchStats from '@js/components/search/BaseSearchStats.vue'
import BaseSearchResult from '@js/components/search/BaseSearchResult.vue'
import BaseSearchFilters from '@js/components/search/BaseSearchFilters.vue'
import BaseSearchWrapper from '@js/components/search/BaseSearchWrapper.vue'
import BaseSearchPagination from '@js/components/search/BaseSearchPagination.vue'
import BaseMobileSearchFilters from '@js/components/search/BaseMobileSearchFilters.vue'

import { env } from '@js/utils/env'

import { AisHit } from '@js/types/search/AisHit'

defineOptions({
  name: 'AppSiteSearchResults',
})

const indexName = computed(() => env.elasticsearch.SEARCH_INDEX)

// Hiding courses that have already started now happens server-side, in the default `wcei`
// search profile — see azure-functions/elasticsearch-proxy/src/lib/profiles/wcei.ts.
</script>
